var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90081 23.2828L2.89502 23.2128L2.90081 22.9268L2.93705 22.7106L2.98131 22.5544L3.03334 22.4191L3.11444 22.256L3.25108 22.0507L3.3969 21.885L12.5969 12.685C13.2705 12.0114 14.3628 12.0114 15.0364 12.685C15.6488 13.2974 15.7045 14.2558 15.2034 14.9311L15.0364 15.1245L8.78196 21.3798L41.4167 21.3798C42.29 21.3798 43.0117 22.0287 43.1259 22.8707L43.1416 23.1048C43.1416 23.9781 42.4927 24.6998 41.6507 24.814L41.4167 24.8298L8.77966 24.8298L15.0364 31.085C15.6488 31.6974 15.7045 32.6558 15.2034 33.3311L15.0364 33.5245C14.424 34.137 13.4657 34.1926 12.7904 33.6916L12.5969 33.5245L3.3969 24.3245L3.1872 24.0709L3.0617 23.8527L2.98093 23.6537L2.92022 23.4183L2.90081 23.2828Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/Arrow-Left.499a4ed03b3c27625c42e4dfda5092ab.svg";
export { ForwardRef as ReactComponent };